export const middlewareProspection = (data: any): IProspection[] =>
  data?.map((item: any) => ({
    id: item.id || '',
    name: item.name || '',
    lastname: item.lastname || '',
    fullname: `${item.name} ${item.lastname}` || '',
    avatar: item.profile_image || '',
    companyFantasyName: item.company || '',
    interests: item.tags || [],
  }));
